/*
 * @Description:
 * @Author: JDY
 * @Date: 2021-04-07 12:00:03
 * @LastEditTime: 2021-04-29 18:34:35
 * @LastEditors: JDY
 */
const getters = {
  isMobile: state => state.app.isMobile,
  lang: state => state.app.lang,
  theme: state => state.app.theme,
  color: state => state.app.color,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  username: state => state.user.info.name,
  welcome: state => state.user.welcome,
  roles: state => state.user.roles,
  userId: state => state.user.info.id,
  userInfo: state => state.user.info,
  addRouters: state => state.permission.addRouters,
  multiTab: state => state.app.multiTab
}

export default getters
